const setupSmartInquiry = () => {
  // TODO: track const { fbq, dataLayer } = require('../lib/analytics');
  $(document).on("click", ".inquiry-form-button", (e) => {
    e.target.dispatchEvent(new CustomEvent("loadSmartInquiry", { bubbles: true }));
  });
};

document.addEventListener("turbolinks:load", setupSmartInquiry);
